/**
*
*   Website Head Content
*       - All the Header SCripts
*
**/
'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { GoogleTagManager } from '@next/third-parties/google';

//Build the Element
export default function Scripts({ ...props }){

	const pathname = usePathname();

	return (
		<head>

			{/* Hyros
			<Script src="https://t.fernandpetal.ca/v1/lst/universal-script?ph=9ea2151e483b18e54a77acdfc13dab915d3980b202e837b23fb5122b9d3aba64&tag=!tracking" />
			*/}

			{/* Google Analytics */}
			<GoogleTagManager gtmId="GTM-NVZKX9B" />
			{/*
			<Script src="https://www.googletagmanager.com/gtag/js?id=G-MKSNXHYC48" onLoad={()=>{
					window.dataLayer = window.dataLayer || [];
					function gtag(){
						dataLayer.push(arguments);
					}
					gtag('js', new Date());
					gtag('config', 'G-MKSNXHYC48');
			}} />
			*/}

			{/* Default */}
			<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
			<meta name="viewport" content="width=device-width,initial-scale=1" />
			<meta name="p:domain_verify" content="5e052fbabcab47b0fe1b5a48d1f29dad"/>
			<meta name="facebook-domain-verification" content="523gcs1ssth1l4ew0egvtpqfmrzhno" />

			{/* Country Codes */}
			<link rel="alternate" hrefLang="x-default" href={ `https://fernandpetal.com${  pathname.replace(/^\/fr\//,'/') }` } />
			<link rel="alternate" hrefLang="en-US" href={ `https://fernandpetal.com${  pathname.replace(/^\/fr\//,'/') }` } />
			<link rel="alternate" hrefLang="en-CA" href={ `https://fernandpetal.ca${  pathname.replace(/^\/fr\//,'/') }` } />
			<link rel="alternate" hrefLang="fr-CA" href={ `https://fernandpetal.ca/fr${  pathname.replace(/^\/fr\//,'/') }` } />

			{/* Canonical */}
			<link rel="shortcut icon" href="/assets/logos/favicon.svg" />

			{/* Styles */}
			<link rel="stylesheet" media="all" href={ 'https://use.typekit.net/ncg0zfr.css' } crossOrigin="anonymous" />

			{/* TripleWhale */}
			<link rel="preconnect dns-prefetch" href="https://api.config-security.com/" crossOrigin="anonymous" />
			<link rel="preconnect dns-prefetch" href="https://conf.config-security.com/" crossOrigin="anonymous" />
			<Script id="tw-pixel" strategy="afterInteractive">{`
				//Triple Whale
				window.TriplePixelData = {
					TripleName: 'fern-petal.myshopify.com',
					ver:        '2.17',
					plat:       'SHOPIFY',
					isHeadless: true
				},

				//Initialize
				function(W,H,A,L,E,_,B,N){function O(U,T,P,H,R){void 0===R&&(R=!1),H=new XMLHttpRequest,P?(H.open("POST",U,!0),H.setRequestHeader("Content-Type","text/plain")):H.open("GET",U,!0),H.send(JSON.stringify(P||{})),H.onreadystatechange=function(){4===H.readyState&&200===H.status?(R=H.responseText,U.includes("/first")?eval(R):P||(N[B]=R)):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(U,T-1,P))}}if(N=window,!N[H+"sn"]){N[H+"sn"]=1,L=function(){return Date.now().toString(36)+"_"+Math.random().toString(36)};try{A.setItem(H,1+(0|A.getItem(H)||0)),(E=JSON.parse(A.getItem(H+"U")||"[]")).push({u:location.href,r:document.referrer,t:Date.now(),id:L()}),A.setItem(H+"U",JSON.stringify(E))}catch(e){}var i,m,p;A.getItem('"!n\`')||(_=A,A=N,A[H]||(E=A[H]=function(t,e,a){return void 0===a&&(a=[]),"State"==t?E.s:(W=L(),(E._q=E._q||[]).push([W,t,e].concat(a)),W)},E.s="Installed",E._q=[],E.ch=W,B="configSecurityConfModel",N[B]=1,O("https://conf.config-security.com/model",5),i=L(),m=A[atob("c2NyZWVu")],_.setItem("di_pmt_wt",i),p={id:i,action:"profile",avatar:_.getItem("auth-security_rand_salt_"),time:m[atob("d2lkdGg=")]+":"+m[atob("aGVpZ2h0")],host:A.TriplePixelData.TripleName,plat:A.TriplePixelData.plat,url:window.location.href.slice(0,500),ref:document.referrer,ver:A.TriplePixelData.ver},O("https://api.config-security.com/event",5,p),O("https://api.config-security.com/first?host=fern-petal.myshopify.com&plat=SHOPIFY",5)))}}("","TriplePixel",localStorage);
			`}</Script>

			{/* Scripts */}
			<Script strategy="lazyOnload" src="https://kit.fontawesome.com/e23f4917a1.js" crossOrigin="anonymous" />
			<Script strategy="lazyOnload" src="https://connect.facebook.net/en_US/sdk.js" />

			{/* Tik Tok */}
			<Script strategy="lazyOnload" onLoad={()=>{
				!function (w, d, t){
				w.TiktokAnalyticsObject = t;const ttq = w[t] = w[t] || [];ttq.methods = ['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie'],ttq.setAndDefer = function (t,e){t[e] = function (){t.push([e].concat(Array.prototype.slice.call(arguments,0)));};};for(let i = 0;i < ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance = function (t){for(var e = ttq._i[t] || [],n = 0;n < ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e;},ttq.load = function (e,n){const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';ttq._i = ttq._i || {},ttq._i[e] = [],ttq._i[e]._u = i,ttq._t = ttq._t || {},ttq._t[e] = +new Date,ttq._o = ttq._o || {},ttq._o[e] = n || {};const o = document.createElement('script');o.type = 'text/javascript',o.async = !0,o.src = `${ i  }?sdkid=${  e  }&lib=${  t }`;const a = document.getElementsByTagName('script')[0];a.parentNode.insertBefore(o,a);};

				ttq.load('CA5SFORL0K1AFEOJ07C0');
				ttq.page();
				}(window, document, 'ttq');
			}}/>

			{/* Facebook */}
			<Script id="facebook-pixel" strategy="afterInteractive">{`
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
			`}</Script>

			{/* Linkedin */}
			<Script id="linkedin-pixel" strategy="afterInteractive">{`
				_linkedin_partner_id = "7168988";
				window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
				window._linkedin_data_partner_ids.push(_linkedin_partner_id);
				(function(l) {
					if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
					window.lintrk.q=[]}
					var s = document.getElementsByTagName("script")[0];
					var b = document.createElement("script");
					b.type = "text/javascript";b.async = true;
					b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
					s.parentNode.insertBefore(b, s);
				})(window.lintrk);
			`}</Script>

			{/* Klaviyo */}
			<Script src="//static.klaviyo.com/onsite/js/klaviyo.js?company_id=RuFegQ" strategy="afterInteractive" />

			{/* Affirm */}
			<Script strategy="afterInteractive" onLoad={()=>{
				const _affirm_config = {
					public_api_key:     '64OGUTPXRPIHGT2G',
					script:             'https://cdn1.affirm.com/js/v2/affirm.js',
					locale:             'en_CA',
					country_code:       'CAN'
				};
				(function (l,g,m,e,a,f,b){let d,c = l[m] || {},h = document.createElement(f),n = document.getElementsByTagName(f)[0],k = function (a,b,c){return function (){a[b]._.push([c,arguments]);};};c[e] = k(c,e,'set');d = c[e];c[a] = {};c[a]._ = [];d._ = [];c[a][b] = k(c,a,b);a = 0;for(b = 'set add save post open empty reset on off trigger ready setProduct'.split(' ');a < b.length;a++)d[b[a]] = k(c,e,b[a]);a = 0;for(b = ['get','token','url','items'];a < b.length;a++)d[b[a]] = function (){};h.async = !0;h.src = g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m] = c;})(window,_affirm_config,'affirm','checkout','ui','script','ready');
				// Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
			}} />

			{/* Intercom */}
			<Script strategy="lazyOnload" onLoad={()=>{
				(function (){const w = window;const ic = w.Intercom;if(typeof ic === 'function'){ic('reattach_activator');ic('update',w.intercomSettings);}else{const d = document;const i = function (){i.c(arguments);};i.q = [];i.c = function (args){i.q.push(args);};w.Intercom = i;const l = function (){const s = d.createElement('script');s.type = 'text/javascript';s.async = true;s.src = 'https://widget.intercom.io/widget/a4r2mo60';const x = d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState === 'complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
			}} />

		</head>
	);

}